import getReferer from "core/utils/getReferer";
import LocalStorage from "core/utils/localstorage";

const ls = new LocalStorage(`apollo`);

// Макросы в форматах adfox (%...%), VAST ([...]) и нашем ({...}), как в getAdUrl
const MACROS = /%system\.random%|\[(?:CACHEBUSTING|timestamp)\]|{\w+}/gi;

/**
 * Подставить макросы в адрес пикселя показа или клика
 *
 * Случайное число новое на каждый вызов, чтобы браузер не отдавал пиксель из
 * кэша. Неизвестные макросы остаются как есть.
 *
 * @param {String} url - Адрес пикселя из кабинета
 */
export default function getPixelUrl(url) {
  if (!url) return url;

  const referer = getReferer();
  const random = String(Math.floor(Math.random() * 100000000));
  const timestamp = String(Math.floor(Date.now() / 1000));

  const values = {
    "%system.random%": random,
    "[cachebusting]": random,
    "[timestamp]": timestamp,
    "{random}": random,
    "{pr}": random,
    "{timestamp}": timestamp,
    "{viewerid}": ls.getItem("viewerId"),
    "{playerdomain}": referer && new URL(referer).hostname,
    "{referer}": referer && encodeURIComponent(referer),
  };

  return url.replace(MACROS, (match) => {
    const value = values[match.toLowerCase()];

    return value === undefined || value === null ? match : value;
  });
}
